import React from "react";

import CircleCodeBackground from "../../../../general/circle-code-background/CircleCodeBackground";

function LeftSideImg() {
  return (
    <div className="left-recap-comp">
      <CircleCodeBackground />
    </div>
  );
}

export default LeftSideImg;
